export default {"src":"/_next/static/media/Website-white.6cc199c9.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};